import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { paths } from '../app/constants'
import { FeatureEnum } from '../models'
import { hasFeature } from '../store/session/selectors'
import { useTranslations } from '../store/translations/hooks'
import { TK } from '../store/translations/translationKeys'

const defaultStyle: React.CSSProperties = {
  display: 'inline-block',
  fontSize: '0.75rem',
  marginTop: '0.25rem',
  color: 'var(--text-muted)',
  textDecoration: 'none',
  opacity: 0.9,
}

export const ClientsIntelligentCategorizationSettingsLink: React.FC<{
  style?: React.CSSProperties
}> = ({ style }) => {
  const t = useTranslations()
  const hasCRMFeature = useSelector(hasFeature(FeatureEnum.CRM))

  if (!hasCRMFeature) {
    return null
  }

  return (
    <Link
      to={paths.clientsIntelligentCategorizationSettings()}
      style={{ ...defaultStyle, ...style }}
      onMouseEnter={(ev) => ev.currentTarget.style.textDecoration = 'underline'}
      onMouseLeave={(ev) => ev.currentTarget.style.textDecoration = 'none'}
    >
      {t(TK.configureIntelligentClientTags)}
    </Link>
  )
}
